/**
 * CompanyLogo — renders a company's logo with the official "Membres de La WineTech"
 * default image as fallback when no logo is set or the image fails to load.
 *
 * Auto-resolves `/api/...` URLs to the backend host (required in production
 * where frontend and backend live on different domains).
 *
 * Usage: <CompanyLogo src={c.logo} name={c.name} size={56} className="rounded-xl" />
 */
import { useState } from "react";

const DEFAULT_LOGO = "/defaults/member-logo.png";
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolveUrl = (u) => (u && u.startsWith("/api/")) ? `${BACKEND}${u}` : u;

export default function CompanyLogo({ src, name, size = 56, className = "" }) {
  const [errored, setErrored] = useState(false);
  const finalSrc = !src || errored ? DEFAULT_LOGO : resolveUrl(src);
  // `object-contain` preserves whatever aspect ratio the company actually
  // uploaded (most have a horizontal or vertical brand mark — not a square),
  // and the neutral white background fills the rest of the box so the layout
  // stays consistent. `p-1` gives 4px breathing room around the logo.
  return (
    <div
      className={`inline-flex items-center justify-center overflow-hidden bg-white p-1 ${className}`}
      style={{ width: size, height: size }}
      data-testid="company-logo-wrap"
    >
      <img
        src={finalSrc}
        alt={name || "Logo"}
        onError={() => setErrored(true)}
        className="max-h-full max-w-full object-contain"
        data-testid="company-logo"
      />
    </div>
  );
}
